const styles = {
  sortBy: {
    backgroundColor: "white",
    height: 35,
    borderRadius: 4,
  },
  filter: {
    fontSize: 12,
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
};

export default styles;
